export function arrayRemove<T>(arr: T[], item: T, key?: keyof T): T[] {
  if (key) {
    return arr.filter((el) => el[key] !== item[key]);
  }

  return arr.filter((el) => el !== item);
}

export default arrayRemove;
